import { object, string } from "yup"

export const iconSchema = object({
  text: string().required(),
  background_color: string().required(),
  font_color: string().required()
})
